import React from 'react'

const BillTile = ({name , amount }) => {
  return (
    <div className='bill-tile'>
       <div>{name}</div>
       <span>{ (name == "Coupons" && amount > 0 )  && "- " }{"\u{20B9}\t"}{amount}</span>
    </div>
  )
}

export default BillTile